import {
  toString30pk9tzaqopn as toString,
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  defineProp3hxgpk2knu2px as defineProp,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Unit_instanceat14thlj150z as Unit_instance,
  AssertionError_init_$Create$1z0wk43yt0tpd as AssertionError_init_$Create$,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
function assertTrue(lazyMessage, actual) {
  if (!actual) {
    this.i5t(lazyMessage());
  }
}
function assertTrue_0(message, actual) {
  this.j5t(Asserter$assertTrue$lambda(message), actual);
}
function assertEquals(message, expected, actual) {
  this.j5t(Asserter$assertEquals$lambda(message, expected, actual), equals(actual, expected));
}
function assertNull(message, actual) {
  this.j5t(Asserter$assertNull$lambda(message, actual), actual == null);
}
initMetadataForInterface(Asserter, 'Asserter');
initMetadataForClass(DefaultJsAsserter$invokeHook$1);
initMetadataForObject(DefaultJsAsserter, 'DefaultJsAsserter', VOID, VOID, [Asserter]);
//endregion
var _asserter;
function Asserter$assertTrue$lambda($message) {
  return function () {
    return $message;
  };
}
function Asserter$assertEquals$lambda($message, $expected, $actual) {
  return function () {
    return messagePrefix($message) + ('Expected <' + toString($expected) + '>, actual <' + toString($actual) + '>.');
  };
}
function Asserter$assertNull$lambda($message, $actual) {
  return function () {
    return messagePrefix($message) + ('Expected value to be null, but was: <' + toString($actual) + '>.');
  };
}
function Asserter() {
}
function assertTrue_1(actual, message) {
  message = message === VOID ? null : message;
  var tmp = get_asserter();
  return tmp.k5t(message == null ? 'Expected value to be true.' : message, actual);
}
function get_asserter() {
  var tmp0_elvis_lhs = _asserter;
  return tmp0_elvis_lhs == null ? lookupAsserter() : tmp0_elvis_lhs;
}
function assertEquals_0(expected, actual, message) {
  message = message === VOID ? null : message;
  get_asserter().l5t(message, expected, actual);
}
function assertFalse(actual, message) {
  message = message === VOID ? null : message;
  var tmp = get_asserter();
  return tmp.k5t(message == null ? 'Expected value to be false.' : message, !actual);
}
function assertNull_0(actual, message) {
  message = message === VOID ? null : message;
  get_asserter().m5t(message, actual);
}
function messagePrefix(message) {
  return message == null ? '' : '' + message + '. ';
}
function get_assertHook() {
  _init_properties_DefaultJsAsserter_kt__dbqvm3();
  return assertHook;
}
var assertHook;
function invokeHook($this, result, lazyMessage) {
  try {
    var tmp = get_assertHook();
    tmp(new DefaultJsAsserter$invokeHook$1(result, lazyMessage));
  }finally {
    $this.n5t_1 = undefined;
    $this.o5t_1 = undefined;
  }
}
function DefaultJsAsserter$assertTrue$lambda($message) {
  return function () {
    return $message;
  };
}
function DefaultJsAsserter$assertTrue$lambda_0($message) {
  return function () {
    return $message;
  };
}
function DefaultJsAsserter$fail$lambda($message) {
  return function () {
    return $message;
  };
}
function DefaultJsAsserter$invokeHook$1($result, $lazyMessage) {
  this.p5t_1 = $result;
  this.q5t_1 = DefaultJsAsserter_getInstance().n5t_1;
  this.r5t_1 = DefaultJsAsserter_getInstance().o5t_1;
  this.s5t_1 = $lazyMessage;
}
protoOf(DefaultJsAsserter$invokeHook$1).s5d = function () {
  return this.p5t_1;
};
protoOf(DefaultJsAsserter$invokeHook$1).t5t = function () {
  return this.q5t_1;
};
protoOf(DefaultJsAsserter$invokeHook$1).u5t = function () {
  return this.r5t_1;
};
protoOf(DefaultJsAsserter$invokeHook$1).v5t = function () {
  return this.s5t_1;
};
function DefaultJsAsserter() {
  DefaultJsAsserter_instance = this;
  this.n5t_1 = undefined;
  this.o5t_1 = undefined;
}
protoOf(DefaultJsAsserter).l5t = function (message, expected, actual) {
  this.n5t_1 = expected;
  this.o5t_1 = actual;
  assertEquals.call(this, message, expected, actual);
};
protoOf(DefaultJsAsserter).m5t = function (message, actual) {
  this.o5t_1 = actual;
  assertNull.call(this, message, actual);
};
protoOf(DefaultJsAsserter).j5t = function (lazyMessage, actual) {
  if (!actual) {
    // Inline function 'kotlin.test.DefaultJsAsserter.failWithMessage' call
    var message = lazyMessage();
    invokeHook(this, false, DefaultJsAsserter$assertTrue$lambda(message));
    // Inline function 'kotlin.test.AssertionErrorWithCause' call
    throw AssertionError_init_$Create$(message, null);
  } else {
    invokeHook(this, true, lazyMessage);
  }
};
protoOf(DefaultJsAsserter).k5t = function (message, actual) {
  this.j5t(DefaultJsAsserter$assertTrue$lambda_0(message), actual);
};
protoOf(DefaultJsAsserter).i5t = function (message) {
  this.w5t(message, null);
};
protoOf(DefaultJsAsserter).w5t = function (message, cause) {
  // Inline function 'kotlin.test.DefaultJsAsserter.failWithMessage' call
  // Inline function 'kotlin.test.DefaultJsAsserter.fail.<anonymous>' call
  var message_0 = message;
  invokeHook(this, false, DefaultJsAsserter$fail$lambda(message_0));
  // Inline function 'kotlin.test.AssertionErrorWithCause' call
  throw AssertionError_init_$Create$(message_0, cause);
};
var DefaultJsAsserter_instance;
function DefaultJsAsserter_getInstance() {
  if (DefaultJsAsserter_instance == null)
    new DefaultJsAsserter();
  return DefaultJsAsserter_instance;
}
function assertHook$lambda(_unused_var__etf5q3) {
  _init_properties_DefaultJsAsserter_kt__dbqvm3();
  return Unit_instance;
}
var properties_initialized_DefaultJsAsserter_kt_jkw377;
function _init_properties_DefaultJsAsserter_kt__dbqvm3() {
  if (!properties_initialized_DefaultJsAsserter_kt_jkw377) {
    properties_initialized_DefaultJsAsserter_kt_jkw377 = true;
    assertHook = assertHook$lambda;
  }
}
function lookupAsserter() {
  return DefaultJsAsserter_getInstance();
}
//region block: post-declaration
defineProp(protoOf(DefaultJsAsserter$invokeHook$1), 'result', function () {
  return this.s5d();
});
defineProp(protoOf(DefaultJsAsserter$invokeHook$1), 'expected', function () {
  return this.t5t();
});
defineProp(protoOf(DefaultJsAsserter$invokeHook$1), 'actual', function () {
  return this.u5t();
});
defineProp(protoOf(DefaultJsAsserter$invokeHook$1), 'lazyMessage', function () {
  return this.v5t();
});
//endregion
//region block: init
_asserter = null;
//endregion
//region block: exports
export {
  assertEquals_0 as assertEquals2dbnhvs25kxwq,
  assertFalse as assertFalse3p42uuboz1ile,
  assertNull_0 as assertNull9duwee51djh,
  assertTrue_1 as assertTrue1upg56ex908m,
};
//endregion

//# sourceMappingURL=kotlin-kotlin-test.mjs.map
